/* eslint-disable react-hooks/exhaustive-deps */
import { ZERO_GUID } from 'modules/enumerations/enumerationIds';

export const createCustomInfoTabs = () => {
  return [{ header: 'Custom Info', order: 1, iconPath: ['fas', 'truck-moving'] }];
};

export const createCustomExceptionTabs = () => {
  return [{ header: 'Exceptions', order: 1, iconPath: ['fas', 'truck-moving'] }];
};

export const createCustomInfoFormData = (approvedLineItem, enumerations) => {
  const item = approvedLineItem ?? {};

  const payTypeOptions = enumerations?.payTypes ?? [];
  const payrollTypeOptions = enumerations?.payrollTypes ?? [];
  const serviceOptions = enumerations?.services ?? [];
  const farCodeOptions = enumerations?.farCodes ?? [];

  const payTypeVal = approvedLineItem?.payTypeId === '' || approvedLineItem?.payTypeId == null ? ZERO_GUID : approvedLineItem?.payTypeId;
  const payrollTypeVal =
    approvedLineItem?.payrollTypeId === '' || approvedLineItem?.payrollTypeId == null ? ZERO_GUID : approvedLineItem?.payrollTypeId;
  const serviceVal = approvedLineItem?.serviceId === '' || approvedLineItem?.serviceId == null ? ZERO_GUID : approvedLineItem?.serviceId;
  const farCodeVal = approvedLineItem?.farCodeId === '' || approvedLineItem?.farCodeId == null ? ZERO_GUID : approvedLineItem?.farCodeId;

  return [
    {
      accessorKey: 'purchaseOrderNumber',
      header: 'PO #',
      type: 'text',
      required: false,
      size: 65,
      value: item.purchaseOrderNumber,
      tab: 1
    },
    {
      accessorKey: 'purchaseOrderDetStatus',
      header: 'PO Det Status',
      type: 'text',
      required: false,
      size: 65,
      value: item.purchaseOrderDetStatus,
      tab: 1
    },
    {
      accessorKey: 'transStatus',
      header: 'Trans Status',
      type: 'text',
      required: false,
      size: 65,
      value: item.transStatus,
      tab: 1
    },
    {
      accessorKey: 'seInvNumber',
      header: 'SE Inv Number',
      type: 'text',
      required: false,
      size: 65,
      value: item.seInvNumber,
      tab: 1
    },
    {
      accessorKey: 'inventoryCurrent',
      header: 'Inventory Current',
      type: 'text',
      required: false,
      size: 65,
      value: item.inventoryCurrent,
      tab: 1
    },
    {
      accessorKey: 'taxableBenefitAmount',
      header: 'Taxable Benefit Amount',
      type: 'money',
      required: false,
      size: 65,
      value: item.taxableBenefitAmount,
      tab: 1
    },
    {
      accessorKey: 'onHoldDate',
      header: 'On Hold Date',
      type: 'date',
      required: false,
      size: 65,
      value: item.onHoldDate,
      tab: 1
    },
    {
      accessorKey: 'taxYear',
      header: 'Tax Year',
      type: 'text',
      required: false,
      size: 65,
      value: item.taxYear,
      tab: 1
    },
    {
      accessorKey: 'farReason',
      header: 'Far Reason',
      type: 'text',
      required: false,
      size: 65,
      value: item.farReason,
      tab: 1
    },
    {
      accessorKey: 'netCheck',
      header: 'Net Check',
      type: 'text',
      required: false,
      size: 65,
      value: item.netCheck,
      tab: 1
    },
    {
      accessorKey: 'payTypeId',
      header: 'Pay Type',
      type: 'dropdown-v2',
      required: false,
      size: 65,
      options: payTypeOptions,
      value: payTypeVal,
      tab: 1
    },
    {
      accessorKey: 'payrollTypeId',
      header: 'Payroll Type',
      type: 'dropdown-v2',
      required: false,
      size: 65,
      options: payrollTypeOptions,
      value: payrollTypeVal,
      tab: 1
    },
    {
      accessorKey: 'serviceId',
      header: 'Service',
      type: 'dropdown-v2',
      required: false,
      size: 65,
      options: serviceOptions,
      value: serviceVal,
      tab: 1
    },
    {
      accessorKey: 'farCodeId',
      header: 'FAR Code',
      type: 'dropdown-v2',
      required: false,
      size: 65,
      options: farCodeOptions,
      value: farCodeVal,
      tab: 1
    },
    {
      accessorKey: 'voidById',
      header: 'Void By (Id)',
      type: 'number',
      required: false,
      size: 65,
      value: item.voidById,
      tab: 1
    },
    {
      accessorKey: 'voidDate',
      header: 'Void Date',
      type: 'date',
      required: false,
      size: 65,
      value: item.voidDate,
      tab: 1
    },
    {
      accessorKey: 'voidInvoiceNumber',
      header: 'Void Invoice Number',
      type: 'text',
      required: false,
      size: 65,
      value: item.voidInvoiceNumber,
      tab: 1
    }
  ];
};

export const createCustomExceptionFormData = () => {
  return [
    {
      accessorKey: 'exceptionDate',
      header: 'Exception Date',
      type: 'date',
      required: false,
      size: 65,
      value: new Date(),
      tab: 1
    },
    { accessorKey: 'exceptionAmount', header: 'Exception Amount', type: 'money', required: false, size: 65, value: 23.0, tab: 1 },
    { accessorKey: 'approvedBy', header: 'Approved By', type: 'text', required: false, size: 65, value: 'JSHOEPKE', tab: 1 },
    {
      accessorKey: 'exceptionReason',
      header: 'Exception Reason',
      type: 'text',
      required: false,
      size: 65,
      value: 'Additional Funds Approved',
      tab: 1
    },
    { accessorKey: 'tempLivingDays', header: 'tempLivingDays', type: 'number', required: false, size: 65, value: 14, tab: 1 },
    { accessorKey: 'exceptionId', header: 'Exception Id', type: 'number', required: false, size: 65, value: 13344, tab: 1 }
  ];
};

export const createCustomInfoPutRequest = (approvedLineItem, formData) => {
  if (!formData) return { ...approvedLineItem };
  return {
    ...approvedLineItem,
    purchaseOrderNumber: formData.purchaseOrderNumber,
    purchaseOrderDetStatus: formData.purchaseOrderDetStatus,
    transStatus: formData.transStatus,
    seInvNumber: formData.seInvNumber,
    inventoryCurrent: formData.inventoryCurrent,
    taxableBenefitAmount: parseFormValue(formData.taxableBenefitAmount, ValueType.FloatType),
    onHoldDate: parseFormValue(formData.onHoldDate, ValueType.DateTimeType),
    taxYear: formData.taxYear,
    farReason: formData.farReason,
    netCheck: formData.netCheck,
    payTypeId: !formData.payTypeId ? ZERO_GUID : formData.payTypeId,
    payrollTypeId: !formData.payrollTypeId ? ZERO_GUID : formData.payrollTypeId,
    serviceId: !formData.serviceId ? ZERO_GUID : formData.serviceId,
    farCodeId: !formData.farCodeId ? ZERO_GUID : formData.farCodeId,
    voidById: parseFormValue(formData.voidById, ValueType.IntType),
    voidDate: parseFormValue(formData.voidDate, ValueType.DateTimeType),
    voidInvoiceNumber: formData.voidInvoiceNumber
  };
};

export const createCustomCurrencyPutRequest = (approvedLineItem, formData) => {
  if (!formData) return { ...approvedLineItem };
  return {
    ...approvedLineItem,
    currencyId: !formData.currencyId ? ZERO_GUID : formData.currencyId,

    receiptAmount: parseFormValue(formData.receiptAmount, ValueType.FloatType),
    payInAmount: parseFormValue(formData.payInAmount, ValueType.FloatType),
    homeAmount: parseFormValue(formData.homeAmount, ValueType.FloatType),
    hostAmount: parseFormValue(formData.hostAmount, ValueType.FloatType),
    usdAmount: parseFormValue(formData.usdAmount, ValueType.FloatType),
    cadAmount: parseFormValue(formData.cadAmount, ValueType.FloatType),
    serviceCompanyAmount: parseFormValue(formData.serviceCompanyAmount, ValueType.FloatType),

    exchangeRateDate: parseFormValue(formData.exchangeRateDate, ValueType.DateTimeType),
    budgetCurrencyAmount: parseFormValue(formData.budgetCurrencyAmount, ValueType.FloatType)
  };
};

export const ValueType = {
  DateTimeType: 0,
  IntType: 1,
  FloatType: 2,
  MoneyType: 3,
  StringType: 4
};

export const parseFormValue = (value, valueType) => {
  if (value === undefined || value === null || value === '') return null;

  switch (valueType) {
    case ValueType.DateTimeType:
      return value;
    case ValueType.IntType:
      return parseInt(value, 10);
    case ValueType.FloatType:
    case ValueType.MoneyType:
      return parseFloat(value);
    case ValueType.StringType:
      return String(value);
    default:
      return null;
  }
};
